import { render, staticRenderFns } from "./Farmer.old.vue?vue&type=template&id=632169eb"
import script from "./Farmer.old.vue?vue&type=script&lang=js"
export * from "./Farmer.old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports